import { Instructor, Maybe, Section } from "@models/ISchema";
import { netUnassignedInstructorIds } from "@utils/unassignedInstructors";
import { EditedSession } from "../context/formData.reducer";
import { getOriginalSessionsById } from "./getOriginalSessionsById";

const instructorIds = (instructors: Maybe<Instructor>[] | null | undefined) =>
  (instructors ?? []).map(instructor => instructor?.id);

/**
 * The instructors the traditional editor unassigned, for `unassignedInstructorIds` (CHS-2944).
 *
 * Receives the sessions sent to sessionsCrud as updates and creates (deleted sessions are not
 * unassignments, so they must be left out). Each one is compared with the saved session it
 * continues: an update with itself and a fork with the session it was split from. The blocked
 * part of a fork keeps the original instructors, so an instructor removed from the future weeks
 * only shows up on the fork. New and cloned sessions continue none.
 */
export const buildUnassignedInstructorIds = (
  sessionsToSave: EditedSession[],
  sections: Section[],
): string[] => {
  const originalSessionsById = getOriginalSessionsById(sections);

  return netUnassignedInstructorIds(
    sessionsToSave.map(session => {
      const originId = Object.keys(session?.forkedWeeksByOriginSessions ?? {})[0] ?? session?.id;

      return {
        originalIds: instructorIds(originalSessionsById[originId]?.instructors),
        // Read as `changeInstructor` sends them, so the list never disagrees with the changeset.
        finalIds: instructorIds(session?.instructors),
      };
    }),
  );
};
